import { TranslationKey } from '@/modules/i18n/types'
import type { PartnerService } from '@duck/api-definitions'

export const getStatusBadgeColor = (active: boolean): string => {
  return active
    ? 'bg-success/10 text-success border border-success/20'
    : 'bg-muted/10 text-muted border border-muted/20'
}

export const formatStatus = (active: boolean): TranslationKey => {
  return active ? 'common.active' : 'common.inactive'
}

export const getTypeBadgeColor = (type: PartnerService.OrganizationType): string => {
  const typeColors = {
    'company': 'bg-accent/10 text-accent border border-accent/20',
    'school': 'bg-blue-500/10 text-blue-500 border border-blue-500/20',
  }
  return typeColors[type] || 'bg-muted/10 text-muted border border-muted/20'
}

export const formatType = (type: PartnerService.OrganizationType): TranslationKey => {
  const typeMap: Record<PartnerService.OrganizationType, TranslationKey> = {
    'company': 'common.company',
    'school': 'common.school',
  }
  return typeMap[type]
}

// Synthetic column keys that don't map to a field on Organization (rendered from
// separately-fetched data). Kept distinct so cell renderers can be typed exhaustively.
export type OrganizationColumnKey = keyof PartnerService.Organization | 'partners'

export interface Column {
  key: OrganizationColumnKey
  label: TranslationKey
  sortable: boolean
  visible: boolean
}

export const baseColumns: Column[] = [
  { key: 'id', label: 'common.id', sortable: true, visible: false },
  { key: 'name', label: 'common.name', sortable: true, visible: true },
  { key: 'description', label: 'common.description', sortable: false, visible: true },
  { key: 'type', label: 'common.type', sortable: true, visible: true },
  { key: 'partners', label: 'organizations.partners', sortable: false, visible: true },
]

